









































































import { Component, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmApi } from '@/services/api/api.realms';

@Component
export default class DownloadDBC extends Vue {
        permissions: string[] = [ApiPermissions.Realm.UploadDBC];

    dbcFiles: string[] = [];
    isLoadingDbcFiles: boolean = false;
    downloadingFile: string | null = null;
    downloadingAll: boolean = false;

    async mounted() {
        await this.fetchDbcFiles();
    }

        async fetchDbcFiles() {
            this.isLoadingDbcFiles = true;

            try {
                const response = await RealmApi.GetDbcFiles();
                this.dbcFiles = response.data ?? [];
            } catch (error) {
                this.$bvToast.toast('Failed to load DBC files', {
                    variant: 'danger',
                    title: 'Error'
                });
            } finally {
                this.isLoadingDbcFiles = false;
            }
        }

        async downloadDbc(fileName: string) {
            if (this.downloadingFile) {
                return;
            }

            this.downloadingFile = fileName;

            try {
                const response = await RealmApi.DownloadDbc(fileName);
                this.downloadBlob(response.data, fileName, response.headers['content-type']);
            } catch (error) {
                this.$bvToast.toast('Failed to download DBC file', {
                    variant: 'danger',
                    title: 'Error'
                });
            } finally {
                this.downloadingFile = null;
            }
        }

        async downloadAllDbc() {
            this.downloadingAll = true;

            try {
                const response = await RealmApi.DownloadAllDbc();
                const fileName = this.getFileNameFromContentDisposition(response.headers['content-disposition']) ?? 'dbc-files.zip';
                this.downloadBlob(response.data, fileName, response.headers['content-type']);
            } catch (error) {
                this.$bvToast.toast('Failed to download all DBC files', {
                    variant: 'danger',
                    title: 'Error'
                });
            } finally {
                this.downloadingAll = false;
            }
        }

        private downloadBlob(blob: Blob, fileName: string, contentType?: string) {
            const typedBlob = blob.slice(0, blob.size, contentType ?? 'application/octet-stream');
            const downloadUrl = window.URL.createObjectURL(typedBlob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }

        private getFileNameFromContentDisposition(contentDisposition?: string) {
            if (!contentDisposition) {
                return undefined;
            }

            const fileNameMatch = contentDisposition.split(';').map(part => part.trim()).find(part => part.startsWith('filename='));
            if (!fileNameMatch) {
                return undefined;
            }

            return fileNameMatch.replace('filename=', '').replace(/"/g, '');
        }
}
